import { Component, inject } from '@angular/core';
import {
  ActionResult,
  DataSource,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  Util
} from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { catchError, first, flatMap, map, Observable, Subject } from 'rxjs';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';
import { ItemWithSelection } from '@app/shared/models/item-with-selection';
import { ParentItemProviderService } from '@app/shared';

@Component({
  selector: 'app-ukloni-fizicki-items-list',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class UkloniFizickiComponent extends ItemsListActionComponent {
  private subject$ = new Subject<Observable<ActionResult>>();

  confirmationService = inject(ConfirmationService);

  parentId = 123;

  constructor(
    protected override notificationService: NotificationService,
    protected override dataSource: DataSource,
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    private parentItemViewProvider: ParentItemProviderService // itemProvider: ItemProvider
  ) {
    super(notificationService, dataSource, listViewProvider);
  }

  protected override doExecute(): Observable<ActionResult> {
    this.confirmationService.confirm({
      message: 'Jeste li sigurni?',
      accept: () => {
        this.subject$.next(super.doExecute());
      }
    });
    this.parentItemViewProvider.parentItem$
      .pipe(first())
      .subscribe((parent: any) => {
        if (parent) {
          this.parentId = parent['en~pojavni_oblik~id']; // Postavljanje ID-a roditeljske stavke u this.parentId
        } else {
          console.error('Parent item not found.');
        }
      });
    return this.subject$.pipe(
      flatMap((p) => p),
      catchError((e) => {
        this.notificationService.error(e.error?.message || e);
        throw e;
      })
    );
  }

  protected override doExecuteWithSelectedItems(items: Array<any>) {
    const item: ItemWithSelection = this.mygetItemWithSelectionData(items);
    return this.dataSource
      .executeAction(this.action.name, item)
      .pipe(map((result) => result as ActionResult));
  }
  mygetItemWithSelectionData(items: any[]): ItemWithSelection {
    return {
      $selected: Util.mapToBasicItemData(items),
      $listName: this.viewName,
      $filterCriteria: (this.listViewProvider?.viewState as any)?.[
        '$filterCriteria'
      ],
      $parentId: this.parentId
    };
  }
}
